import React from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';

const CreateNew = (props) => {
	const {curState,createTagChangeHandler,toggleModel,saveTagDetails} = props;
    const {isModalOpen,name} = curState;
	return (
		<Modal size="sm" show={isModalOpen} onHide={toggleModel}>
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2"> {(!curState.isEdit) ? 'Add Tag':'Edit Tag'} </h5>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col">
                        <div className="form-group">
                            <label> Name </label>
                            <input type="text" value={name} name="name" onChange={createTagChangeHandler} className="form-control" />
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
               <div className="ml-md-auto py-2 py-md-0">
                    <a onClick={toggleModel} className="btn btn-border border-default mr-2"> Cancel </a> 
                    <a onClick={saveTagDetails} className="btn primary_bg"> Save </a> 
                </div>
            </Modal.Footer>
		</Modal>
	);
}

export default withRouter(CreateNew);